import { OptionalStateCarts, StateCartEntry } from '../store/carts/CartsState';
import { CartTypeQuantityData } from './pushToDataLayer';
import { CustomOrderType } from '../store/carts/CustomOrderType';

enum OrderTypeKey {
  COLLECT_AT_STORE = 'cc_count',
  HOME_DELIVERY = 'hd_count'
}

export function calculateCartQuantities(
  currentCartState: OptionalStateCarts
): CartTypeQuantityData {
  return Object.fromEntries(
    Object.values(CustomOrderType).map((type) => [
      OrderTypeKey[type],
      currentCartState[type]?.entries.reduce(
        (partialSum: number, entry: StateCartEntry) => partialSum + entry.quantity,
        0
      ) ?? 0
    ])
  );
}
